// MOVER UNA POLIZA A OTRO CLIENTE — la parte que se puede probar.
//
// Espejo de `deskte-api/src/utils/moverPoliza.ts`, que es donde esta razonado
// el porque. Aqui vive SOLO la cuenta que la pantalla necesita para avisar
// ANTES de mover, y vive en un archivo suelto —y no dentro del componente— por
// dos motivos:
//
//  1. Un componente arrastra `api.js` y con el MSAL, que necesita `window`: las
//     pruebas del servidor, que corren en Node, no lo pueden importar. Este
//     archivo no importa nada, asi que si se puede probar contra la funcion del
//     servidor y comprobar que las dos cuentan LO MISMO.
//  2. Es el mismo reparto que ya usan `clientFilters.js` y `customColumns.js`:
//     la logica pura fuera, la pantalla solo la pinta.
//
// EL AVISO Y LO QUE PASA TIENEN QUE SER LA MISMA COSA. La pantalla dice "se
// desmarcan 2" y el servidor desmarca; si las dos cuentas se separan, el aviso
// miente, y un aviso que miente es peor que no avisar.

/**
 * Cuantas personas aseguradas se van a desmarcar al mover, y cuantos numeros de
 * tarjeta se quedan sin dueno.
 *
 * Es lo MISMO que resetea `camposAlMoverPoliza` en el servidor: todo lo que no
 * sea el titular. Las claves de `policyInsured` son del hogar del cliente
 * ("primary", "spouse", el id de cada dependiente), asi que al cambiar de
 * cliente dejan de significar lo que decian.
 */
export function loQueSeResetea(policy) {
  const marcadas = Array.isArray(policy?.policyInsured) ? policy.policyInsured : [];
  const mapa = policy?.memberIdsByPerson && typeof policy.memberIdsByPerson === 'object'
    ? policy.memberIdsByPerson : {};
  return {
    asegurados: marcadas.filter((k) => k && k !== 'primary').length,
    numeros: Object.keys(mapa).filter((k) => k && k !== 'primary' && mapa[k]).length,
  };
}
